module.exports = __webpack_public_path__ + "static/media/pause-button.06b9186f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Player/pause-button.svg
// module id = 492
// module chunks = 0